import { DiscountType } from "../../models";
export const billClientLoader = 'billClientLoader';
export let BillMode = /*#__PURE__*/function (BillMode) {
  BillMode["Now"] = "now";
  BillMode["Upcoming"] = "upcoming";
  BillMode["FutureDate"] = "futureDate";
  return BillMode;
}({});
export let BillingType = /*#__PURE__*/function (BillingType) {
  BillingType["Charge"] = "charge";
  BillingType["Service"] = "service";
  return BillingType;
}({});
export const InitialDiscount = {
  type: DiscountType.Percent,
  amount: ''
};